import React, { useState, useEffect } from "react";
import { useApp } from "context";
import { Custom, Progress } from "components";
import { Helpers, Routes } from "utils";
import { Box } from "@mui/material";
import { IAppointment } from "interfaces";

type Props = {
  // TODO: it may be improved (currently being used to force the updated of the appointments)
  incrementComponent: number;
  onChange: (countAppointments: number) => void;
};

export const Journey = (props: Props) => {
  const [currentLength, setCurrentLength] = useState(0);
  const [appointments, setAppointments] = useState<IAppointment[] | null>(null);
  const { t, locale, service } = useApp();

  useEffect(() => {
    getAppointments();
  }, [props.incrementComponent]);

  const countAppointments =
    appointments?.filter((x: IAppointment) =>
      Helpers.compareTo(new Date(x.scheduledTime), new Date())
    ).length ?? 0;

  const getAppointments = async () => {
    const response = await service.appointment.journey(currentLength, 5);
    setAppointments(response.appointments);
    props.onChange && props.onChange(countAppointments);
  };

  const getAppointmentMessage = (item: IAppointment) => {
    return item.clinic
      ? Helpers.interpolate(t.message.appointment.consult_clinic, {
          name: item.clinic.username,
        })
      : Helpers.interpolate(t.message.appointment.consult_provider, {
          name: item.provider.username,
        });
  };

  return (
    <Custom.Card
      sx={{ height: 305 }}
      title={t.title.patient.journey}
      href={Routes.patient.journey}
    >
      <Box sx={{ position: "relative" }}>
        {appointments ? (
          appointments.length > 0 ? (
            <Custom.Timeline>
              {appointments.map((item: IAppointment, i: number) => {
                const date = new Date(item.scheduledTime);
                const isToday = Helpers.compareTo(date, new Date());
                return (
                  <Custom.TimelineItem
                    key={i}
                    title={Helpers.toRelativeDate(
                      item.scheduledTime,
                      t.relative_date,
                      locale
                    )}
                    subtitle={getAppointmentMessage(item)}
                    date={item.scheduledTime}
                  />
                );
              })}
            </Custom.Timeline>
          ) : (
            <Progress.NoRecord height={200} />
          )
        ) : (
          Helpers.generateArray(4).map(function (_, i: number) {
            return <Progress.PlaceholderItem key={i} />;
          })
        )}
      </Box>
    </Custom.Card>
  );
};
